import React, {useState, useEffect} from "react";
import ChatGrid from "./ChatGrid";
import ChatbotResponseTabs from "./ChatbotResponseTabs";
import "./Chatbot.css";

function ResponseRenderer({response,setErrorMessage}){

  const [objectKey, setObjectKey] = useState("");

  useEffect(() => {
    if (response) {
      for (let key in response) {
        if (Array.isArray(response[key])) {
          setObjectKey(key);
          break;
        }
      }
    }
  }, [response]);

  useEffect(() => {
    if (objectKey !== "" && response[objectKey]?.length === 0) {
      setErrorMessage(
        "We apologize for the inconvenience, but due to technical issues, our search service is temporarily unavailable. Please try again later."
      );
    }
  }, [objectKey, response, setErrorMessage]);

  if (!response) {
    return null;
  }

  const determineResponseType = (resp) => {
    if (typeof resp === "object" && resp !== null) {
      if ("output" in resp && typeof resp.output === "string") {
        return "text";
      }

      for (let key in resp) {
        if (Array.isArray(resp[key])) {
          return "objectWithList";
        }
      }

      return "object";
    }

    if (Array.isArray(resp)) {
      if (resp.length === 0) {
        setErrorMessage(
          "We apologize for the inconvenience, but due to technical issues, our search service is temporarily unavailable. Please try again later."
        );
      }
      return "list";
    }

    return "text";
  };
  const responseType = determineResponseType(response);
  switch (responseType) {
    case "list":
      return <ChatGrid response={response} responseType={responseType}/>;

    case "objectWithList":
      return <ChatGrid response={response} responseType={responseType}/>;

    case "object":
      return <pre>
        {/* {JSON.stringify(response, null, 2)} */}
        </pre>;
    case "text":
      const parsedText = (()=>{
        if(typeof response?.output === 'string'){
          return response.output
        }
        else{
          return response?.output?.split(":")?.slice(1)?.join(":")
        }
      })
      return <p>{parsedText || response}</p>
    default:
      return <p>{response}</p>;
  }
};

export default ResponseRenderer;